import axios from 'axios'
import userService from './userService'
import { getEnvVar } from '@/assets/js/helpers'

const CancelToken = axios.CancelToken
let cancelGetRequest
let cancelGetMembers

const apiClient = axios.create({
  baseURL: getEnvVar('VUE_APP_API_URL') + 'manage/'
})

apiClient.interceptors.request.use((config) => {
  config.params = config.params || {}
  if (userService.debugUserId) {
    config.params.debugUser = userService.debugUserId
  }
  return config
})

export default {
  getMembers ({ clubCode, searchString, offset, take }) {
    if (cancelGetMembers) {
      cancelGetMembers('canceled')
    }
    return apiClient.post('/members/list', {
      clubCode,
      searchString,
      offset,
      take
    }, {
      cancelToken: new CancelToken(function executor (c) {
        cancelGetMembers = c
      })
    })
  },
  getRequests ({ clubCode, searchString, offset, take }) {
    if (cancelGetRequest) {
      cancelGetRequest('canceled')
    }
    return apiClient.post('/requests/list', {
      clubCode,
      searchString,
      offset,
      take
    }, {
      cancelToken: new CancelToken(function executor (c) {
        cancelGetRequest = c
      })
    })
  },
  getRequestsCount (clubCode) {
    return apiClient.post('/requests/list', {
      clubCode,
      searchString: null,
      offset: 0,
      take: 1
    })
  },
  acceptRequest ({ clubCode, userId }) {
    return apiClient.post('/requests/approve', {
      clubCode,
      userId
    })
  },
  rejectRequest ({ clubCode, userId }) {
    return apiClient.post('/members/reject-and-exclude', {
      clubCode,
      userId
    })
  },
  changeManager ({ clubCode, userId }) {
    return apiClient.post('/changeManager', {
      ClubCode: clubCode,
      NewManagerId: userId
    })
  }
}
